<template>
  <label
    class="custom-checkbox-wrapper"
    :for="identifier"
  >
    <input
      :id="identifier"
      ref="input"
      v-model="innerValue"
      type="checkbox"
      :value="identifier"
      :indeterminate.prop="indeterminate"
      :disabled="disabled"
    />
    <span class="custom-checkbox-box" />
    <span class="custom-checkbox-label"><slot /></span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    identifier: {
      type: String,
      default: undefined,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
